<template>
  <div class="strategy-manager page-box">
    <div class="page-content">
      <div class="content-header">
        <div class="m-input-outer">
          <el-input
            class="box-item"
            placeholder="请输入"
            style="width: 100%"
            v-model="touser"
          ></el-input>
        </div>
        <el-input
          class="hidden-xs-only"
          placeholder="请输入"
          style="width: 150px"
          v-model="touser"
        ></el-input>
        <vs-button
          type="info"
          class="search-btn btn box-item"
          @click="searchHandle"
        >查询</vs-button>
        <vs-button
          v-if="isAuth('wx:spiderArticle:delete')"
          :disabled="selected.length < 1"
          class="mutil-btn "
          @click="deleteHandle()"
        >批量删除</vs-button>
      </div>
      <div class="vs-table-outer">
        <vs-table
          multiple
          v-model="selected"
          :data="listData"
        >
          <template
            slot="thead">
            <vs-th>
              openid
            </vs-th>
            <vs-th>
              内容
            </vs-th>
            <vs-th>
              发送结果
            </vs-th>
            <vs-th>
              发送时间
            </vs-th>
            <vs-th>
              链接
            </vs-th>
            <vs-th>
              小程序
            </vs-th>
            <vs-th>
              操作
            </vs-th>
          </template>
          <template slot-scope="{data}">
            <vs-tr
              v-for="(tr, index) in data"
              :key="index"
              :data="tr"
            >
              <vs-td>
                {{tr.touser}}
              </vs-td>
              <vs-td
              >
               {{tr.data}}
              </vs-td>
              <vs-td
              >
                {{tr.sendResult}}
              </vs-td>
              <vs-td>
                {{tr.sendTime}}
              </vs-td>
              <vs-td>
                {{tr.url}}
              </vs-td>
              <vs-td>
                {{tr.miniprogram}}
              </vs-td>
              <vs-td>
                <el-button
                  v-if="isAuth('wx:templatemsglog:delete')"
                  type="text"
                  class="delete-btn"
                  @click.native="deleteHandle(tr.id)"
                >删除</el-button>
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </div>
      <div class="pagination-outer" v-if="total">
        <div class="paginnation-left">
          <size-change @sizeChange="sizeChange"></size-change>
          <span class="tatol-count">合计 {{total}} 条</span>
        </div>
        <vs-pagination
          class="pagination-box"
          :max="max"
          :total="pageSize"
          v-model="page"
        ></vs-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { parseTime } from '@/utils'
import initData from "@/mixins/initData";
import {deleteTmpMsgLog} from "../../../api/wx/template-msg-log";
export default {
  name: "index",
  components: {

  },
  data() {
    return {
      touser: '',
      selected: [],
    }
  },
  mixins: [initData],
  computed: {
    ...mapGetters(['themeColor','userInfo']),
  },
  mounted(){
    this.init();
  },
  methods: {
    parseTime,
    beforeInit(){
      this.url = '/wx/manage/templateMsgLog/list';
      this.params = {
        page: this.page,
        limit: this.size,
        'sidx': 'send_time',
        'order':'desc',
      }
      if(this.touser){
        this.params.strategyId = header.type;
      }

      return true;
    },
    deleteHandle(id){
      let ids = id ? [id] : this.selected.map(item => item.id);
      this.$confirm(`确定对[id=${ids.join(',')}]进行[${id ? '删除' : '批量删除'}]操作?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteTmpMsgLog(ids).then((res) => {
          this.$message({
            type: 'success',
            message: '已删除'
          });
          this.searchHandle();
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    searchHandle(){
      this.page = 1;
      this.init();
    },
  },
}
</script>

<style lang="scss" scoped>
.strategy-manager {
  .box-item {
    margin-bottom: 10px;
  }
  .btn {
    margin-right: 10px;
  }
  .vs-table-outer {
    .vs-con-table {
      min-width: 1200px;
    }
  }
  .tag-box {
    padding: 5px 10px;
    border-radius: 15px;
  }
  .vs-table--tr .vs-table--td > span {
    white-space: normal!important;
  }
}
</style>
